<template>
  <div class="dialogpage bg pa">
    <div class="bigbox" @touchmove.prevent>
      <div class="home pr">
        <!-- <div class="pagebox pr"> -->
        <div class="book pa" ref="book">
          <template v-for="(item, index) in questionList">
            <div class="page page1 pa" :key="index">
              <div class="page_content">
                <div class="test_quetion_box">
                  <p class="quetions_num">
                    <span>0{{ item.id }}/04</span>
                  </p>
                  <p class="para">
                    <span>Q:</span>
                    <b>{{ item.title }}</b>
                  </p>
                </div>
                <ul class="test_ans_list">
                  <li class="kompb">
                    <div
                      class="test_ansin dl"
                      data-value="A"
                      @click="select($event, 1, item.id)"
                    >
                      <span>{{ item.option_a }}</span>
                      <img
                        v-if="tickimg1"
                        src="../../assets/dialog-images/tick.png"
                        alt=""
                        class="tick"
                      />
                    </div>
                  </li>
                  <li class="kompb">
                    <div
                      class="test_ansin dl"
                      data-value="B"
                      @click="select($event, 2, item.id)"
                    >
                      <span>{{ item.option_b }}</span>
                      <img
                        v-if="tickimg2"
                        src="../../assets/dialog-images/tick.png"
                        alt=""
                        class="tick"
                      />
                    </div>
                  </li>
                  <li class="kompb">
                    <div
                      class="test_ansin dl"
                      data-value="C"
                      @click="select($event, 3, item.id)"
                    >
                      <span>{{ item.option_c }}</span>
                      <img
                        v-if="tickimg3"
                        src="../../assets/dialog-images/tick.png"
                        alt=""
                        class="tick"
                      />
                    </div>
                  </li>
                  <li class="kompb">
                    <div
                      class="test_ansin dl"
                      data-value="D"
                      @click="select($event, 4, item.id)"
                    >
                      <span>{{ item.option_d }}</span>
                      <img
                        v-if="tickimg4"
                        src="../../assets/dialog-images/tick.png"
                        alt=""
                        class="tick"
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div class="page_back pa"></div>
              <!-- <div class="page_footer pa dl">
              <div @click="prevPage($event)">第1页</div>
              /
              <div @click="nextPage1($event)">共5页</div>
            </div> -->
            </div>
          </template>
        </div>
        <img
          src="../../assets/images/toast_btn.png"
          alt=""
          class="pagebox_Img"
          @click="closePop"
        />
      </div>
      <img
        @click="nextPage(e, indexPage)"
        src="../../assets/dialog-images/Confirm_btn.png"
        alt=""
        class="Confirm_btn"
      />
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "homePage",
  props: ["questionList"],
  data() {
    return {
      ansList: [],
      tickimg1: false,
      tickimg2: false,
      tickimg3: false,
      tickimg4: false,
      itemAns: {},
      e: "",
      indexPage: "",
      ischiose: false,
      timer: null,
      // fullHeight: "", //fullHeight: document.documentElement.clientHeight  屏幕高度 默认值
      // timer: false,
    };
  },
  created() {},
  mounted() {
    if (this.$util._isMobile()) {
      // alert("移动端");
      // let fullHeight = document.documentElement.clientHeight;
      // let fullWidth = document.documentElement.clientWidth;
      // let proportion = fullHeight / fullWidth; //可视宽高比
      let book = document.getElementsByClassName("book")[0];
      let bookwidth = book.offsetWidth;
      book.style.height = bookwidth * 1.69 + "px";
    }
  },
  // watch: {
  //   fullHeight(val) {
  //     let that = this;
  //     if (!this.timer) {
  //       this.fullHeight = val;
  //       this.changeFixed(this.fullHeight);
  //       this.timer = true;
  //       setTimeout(() => {
  //         that.timer = false;
  //       }, 100);
  //     }
  //   },
  // },
  methods: {
    // changeFixed(value) {
    //   this.$refs.book.style.height = value - 35 + "px";
    // },
    closePop() {
      (this.ansList = []),
        (this.itemAns = {}),
        (this.e = ""),
        (this.indexPage = ""),
        (this.tickimg1 = false),
        (this.tickimg2 = false),
        (this.tickimg3 = false),
        (this.tickimg4 = false),
        (this.timer = null),
        (this.ischiose = false),
        this.$emit("qvxiao");
    },
    // 上一页
    // prevPage(e) {
    //   // 获取到 class 名为 page 的元素下一个兄弟元素
    //   let a = e.currentTarget.parentNode.parentNode.nextElementSibling;
    //   if (a != null) {
    //     a.style.transform = "perspective(2000px) rotateY(0deg)";
    //   }
    // },
    // 选择
    select(e, index, id) {
      // console.log(e.currentTarget.dataset.value, index, id);
      let ts = {};
      if (index == 1) {
        this.tickimg1 = true;
        this.tickimg2 = false;
        this.tickimg3 = false;
        this.tickimg4 = false;
        ts.id = id;
        ts.score = e.currentTarget.dataset.value;
        this.itemAns = ts;
        this.e = e.currentTarget.parentNode.parentNode.parentNode.parentNode;
        this.indexPage = id;
        this.ischiose = true;
        // console.log(this.itemAns);
      } else if (index == 2) {
        this.tickimg1 = false;
        this.tickimg2 = true;
        this.tickimg3 = false;
        this.tickimg4 = false;
        ts.id = id;
        ts.score = e.currentTarget.dataset.value;
        this.itemAns = ts;
        this.e = e.currentTarget.parentNode.parentNode.parentNode.parentNode;
        this.indexPage = id;
        this.ischiose = true;
        // console.log(this.itemAns);
      } else if (index == 3) {
        this.tickimg1 = false;
        this.tickimg2 = false;
        this.tickimg3 = true;
        this.tickimg4 = false;
        ts.id = id;
        ts.score = e.currentTarget.dataset.value;
        this.itemAns = ts;
        this.e = e.currentTarget.parentNode.parentNode.parentNode.parentNode;
        this.indexPage = id;
        this.ischiose = true;
        // console.log(this.itemAns);
      } else {
        this.tickimg1 = false;
        this.tickimg2 = false;
        this.tickimg3 = false;
        this.tickimg4 = true;
        ts.id = id;
        ts.score = e.currentTarget.dataset.value;
        this.itemAns = ts;
        this.e = e.currentTarget.parentNode.parentNode.parentNode.parentNode;
        this.indexPage = id;
        this.ischiose = true;
        // console.log(this.itemAns);
      }
      //获取到点击的那个答案
      // let c = e.currentTarget.parentNode;
      // c.style.color = "#298adb"; //选中 答案变色
    },
    // 下一页
    nextPage(a, index) {
      // console.log(this.itemAns);
      // console.log(a,index,this.questionList.length);
      // 获取到 class 名为 page 的元素
      // let a =
      //   e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode;
      // let itemAns = {
      //   id: index,
      //   score: e.currentTarget.dataset.value,
      // };
      if (this.ischiose) {
        console.log(this.ischiose);
        // this.ischiose 选中其一才能下一题
        this.ansList.push(this.itemAns);
        if (index === this.questionList.length) {
          // alert("提交");
          this.$emit("page", this.ansList);
          this.ischiose = false;
          this.$bus.$emit("notest");
        } else {
          a.style.transform = "perspective(2000px) rotateY(-180deg)"; //翻页
          this.e = "";
          this.indexPage = "";
          this.ischiose = false;
          setTimeout(() => {
            this.tickimg1 = false;
            this.tickimg2 = false;
            this.tickimg3 = false;
            this.tickimg4 = false;
          }, 600);
          console.log(this.ansList);
        }
      }
    },
    // nextPage1(e) {
    //   console.log(e);
    //   // 获取到 class 名为 page 的元素
    //   let a = e.currentTarget.parentNode.parentNode;
    //   // 获取到 class 名为 page 的元素上一个兄弟元素
    //   let b =
    //     e.currentTarget.parentNode.parentNode.previousElementSibling;
    //   if (b != null) {
    //     a.style.transform = "perspective(2000px) rotateY(-180deg)";
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.dialogpage {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 7.5rem;
  height: 100vh;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  // .mask {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(0, 0, 0, 0.7);
  // }
  .bigbox {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.home {
  -webkit-tap-highlight-color: transparent; //去除移动端点击产生背景色
  height: 100%;
  overflow: hidden;
  background: url("../../assets/dialog-images/image/pagebg.png");
  background-size: 100% 100%;
  // background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0.3rem;
  width: 100%;
  // .pagebox {
  //   height: 100%;
  .book {
    width: 6.5rem;
    height: 7.3rem;
    // height: 650px;
    transform-style: preserve-3d;
    left: 51%;
    top: 50.5%;
    transform: translate(-50%, -50%);
  }
  .page {
    width: 100%;
    height: 100%;
    transform-origin: left;
    transform-style: preserve-3d;
    transform: perspective(1500px) rotateY(0deg);
    transition: transform 1s ease-in;
    display: flex;
    .page_content {
      text-align: center;
      width: 100%;
      height: 100%;
      padding: 0.5rem 0.3rem;
      box-sizing: border-box;
      // background: linear-gradient(90deg, #747474, 4%, #ffffff);
      background: url("../../assets/dialog-images/book_bg.png") no-repeat;
      background-position: center;
      z-index: 1;
      backface-visibility: hidden; //背面隐藏
      .test_quetion_box {
        width: 100%;
        .quetions_num {
          color: #ffffff;
          background: url("../../assets/dialog-images/serial.png") no-repeat;
          background-size: 100% 100%;
          text-align: center;
          width: 1rem;
          line-height: 0.3rem;
          height: 0.3rem;
          font-size: 0.2rem;
        }
        .para {
          width: 100%;
          position: relative;
          font-size: 0.3rem;
          font-weight: bold;
          box-sizing: border-box;
          text-align: left;
          display: flex;
          line-height: 0.5rem;
          color: #1d1d1d;
          // &::before {
          //   content: "";
          //   width: 100%;
          //   background: url(https://static.gamamobi.com/static/act/slnstw/match/ossweb-img/ques_line.png)
          //     no-repeat;
          //   background-size: 100% 100%;
          //   position: absolute;
          //   top: -2px;
          //   height: 1px;
          // }
          &::after {
            content: "";
            width: 100%;
            // background: url(https://static.gamamobi.com/static/act/slnstw/match/ossweb-img/ques_line.png)
            // no-repeat;
            background: #000;
            background-size: 100% 100%;
            position: absolute;
            bottom: -2px;
            height: 1px;
          }
        }
      }
      .test_ans_list {
        text-align: left;
        font-size: 0.27rem;
        color: #5a5959;
        padding-top: 1rem;
        .kompb {
          height: 1rem;
          color: #1d1d1d;
          .test_ansin {
            span {
              padding-left: 0.4rem;
              cursor: pointer;
              font-size: 0.4rem;
              font-weight: 500;
              color: #1d1d1d;
            }
            &::after {
              cursor: pointer;
              content: "";
              display: inline-block;
              vertical-align: top;
              // background: url("https://static.gamamobi.com/static/act/slnstw/match/ossweb-img/ans_icon.png")
              //   no-repeat;
              background: #1c1c1c;
              background-size: 100% 100%;
              position: absolute;
              left: 0.3rem;
              width: 0.3rem;
              height: 0.25rem;
            }
            .tick {
              position: absolute;
              left: 0.3rem;
              width: 0.3rem;
              z-index: 1;
            }
          }
          .activeColor {
            color: #298adb;
          }
        }
      }
    }
    .page_back {
      width: 100%;
      height: 100%;
      // background: linear-gradient(90deg, #747474, 4%, #ffffff);
      background: url("../../assets/dialog-images/book_bg.png") no-repeat;
      background-position: center;
    }
    .page_footer {
      bottom: 5px;
      right: 10px;
      div {
        cursor: pointer;
      }
    }
  }
  .pagebox_Img {
    position: absolute;
    top: 2%;
    right: 6%;
    width: 1.2rem;
    cursor: pointer;
  }
}
.Confirm_btn {
  position: absolute;
  bottom: 0%;
  width: 4rem;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
// }
// @media screen and (min-width: 655px) {
//   .home {
//     // margin: 0 auto;
//     // width: 5.2rem;
//     .book {
//       // width: 4.3rem !important;
//       height: 7.5rem !important;
//     }
//     .Confirm_btn {
//       bottom: 0%;
//     }
//   }
// }
// @media screen and (min-width: 750px) {
//   .home {
//     // margin: 0 auto;
//     // width: 5.2rem;
//     .book {
//       // width: 5.5rem !important;
//       height: 7.5rem !important;
//       // max-width: 360px;
//       // max-height: 544px;
//     }
//     .Confirm_btn {
//       bottom: 0%;
//     }
//   }
// }
</style>